
<template>
  <!-- eslint-disable -->
  <svg :style="style" :class="classes" data-components="SearchSmallSvg" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><g fill="none" fill-rule="evenodd"><path fill="#EE7C00" d="M10.301 0C4.612 0 .001 4.612.001 10.301s4.611 10.302 10.3 10.302c5.69 0 10.301-4.613 10.301-10.302C20.602 4.612 15.99 0 10.302 0m0 3c4.025 0 7.3 3.275 7.3 7.301s-3.275 7.302-7.3 7.302C6.274 17.603 3 14.327 3 10.301S6.275 3 10.301 3"/><path stroke="#fff" stroke-linecap="round" stroke-width="3" d="M16.954 17.001l5.448 5.448"/></g></svg>
</template>

<script>
import globalMixin from 'Libs/mixins/globalMixin';

export default {
  name: 'SearchSmallSvg',
  mixins: [globalMixin],
  props: {
    width: {
      type: [String, Number, Boolean],
      default: false
    },
    height: {
      type: [String, Number, Boolean],
      default: false
    },
    original: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    style() {
      const style = {};

      if (this.width) {
        style.width = this.width + 'px';
      }

      if (this.height) {
        style.height = this.height + 'px';
      }

      return style;
    }
  }
};
</script>
